import { render, staticRenderFns } from "./project-album.vue?vue&type=template&id=3629a936&scoped=true&"
import script from "./project-album.vue?vue&type=script&lang=js&"
export * from "./project-album.vue?vue&type=script&lang=js&"
import style0 from "./project-album.vue?vue&type=style&index=0&id=3629a936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3629a936",
  null
  
)

export default component.exports